import { useForm, useStore } from '@tanstack/react-form'
import { isEqual } from 'lodash'
import { CompanySelect, FF, FilterPanel, Select, TextInput } from 'ui/components'
// eslint-disable-next-line max-len
import { useSiteAuditDocumentsReportContext } from '~bank-reports/routes/SiteAuditDocumentsReport/context/SiteAuditDocumentsReportContext'
import {
  SiteAuditDocumentsReportFilterParams,
  siteAuditDocumentsReportFilterParamsSchema
} from '~bank-reports/types/SiteAuditDocumentsReport'

import { s } from './styles'

export const Filter = () => {
  const { data, state, navigate, clear } = useSiteAuditDocumentsReportContext()
  const { frequencyOptions = [], relationshipOptions = [] } = data || {}

  const formApi = useForm({
    defaultValues: state as Pick<SiteAuditDocumentsReportFilterParams, 'frequency' | 'relationshipId' | 'licenseNumber'>
  })

  const clearForm = () => {
    formApi.reset()
    clear()
  }

  return (
    <FilterPanel
      isDirty={
        useStore(formApi.store, (s) => s.isDirty) ||
        !isEqual(siteAuditDocumentsReportFilterParamsSchema.parse({}), state)
      }
      onReset={clearForm}
    >
      <s.FormWrapper>
        <s.Row>
          <formApi.Field
            name="relationshipId"
            listeners={{
              onChange: ({ value, fieldApi }) => {
                navigate({ [fieldApi.name]: value, page: 1 })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                label="Relationship"
                field={field}
                input={(inputProps) => (
                  <CompanySelect
                    preloadedOptions={relationshipOptions}
                    data-qa="Relationship"
                    options-data-qa="Relationship"
                    hideMyCompaniesFilter
                    {...inputProps}
                  />
                )}
              />
            )}
          />

          <formApi.Field
            name="licenseNumber"
            listeners={{
              onChange: ({ value, fieldApi }) => {
                navigate({ [fieldApi.name]: value, page: 1 })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                label="License Number"
                field={field}
                input={(inputProps) => <TextInput {...inputProps} data-qa="License Number" />}
              />
            )}
          />

          <formApi.Field
            name="frequency"
            listeners={{
              onChange: ({ value, fieldApi }) => {
                navigate({ [fieldApi.name]: value, page: 1 })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                label="Frequency"
                field={field}
                input={(inputProps) => (
                  <Select data={frequencyOptions} data-qa="Frequency" options-data-qa="Frequency" {...inputProps} />
                )}
              />
            )}
          />
        </s.Row>
      </s.FormWrapper>
    </FilterPanel>
  )
}
